import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LatestEntryFormTable from "../componets/Dashboard/LatestEntryFormTable";
import RecentSignup from "../componets/Dashboard/RecentSignup";
import Header from "../componets/Layout/Header";
import Sidebar from "../componets/Layout/Sidebar";
import { getDashboard } from "../controller";
import { requestHandler } from "../helper";

function Dashboard({ tabledata }) {
    const [dashboardData, setDashboardData] = useState({});
    const navigate = useNavigate();
    const data = [
        {
            image: "../images/png/total-user.png",
            title: "Total Active Users",
            label: "totalActiveUsersCount",
        },
        {
            image: "../images/png/book1.png",
            title: "Total Entry Form",
            label: "totalEntryFormsCount",
        },
        {
            image: "../images/png/category1.png",
            title: "Total Category",
            label: "totalCategoryCount",
        },
        {
            image: "../images/png/template1.png",
            title: "Total Template",
            label: "totalTemplatesCount",
        },
    ];

    const getDashboardDetails = async () => {
        await requestHandler(
            async () => await getDashboard(),
            null,
            (res) => {
                setDashboardData(res.data);
            },
            () => { }
        );
    };

    useEffect(() => {
        getDashboardDetails();
    }, []);



    return (
        <>
            <div className="layouy-main">
                <div className="sidebar-hide-show">
                    <Sidebar />
                </div>
                <div className="w-100">
                    <Header />
                    <div className="tebs-title">
                        <p className="active">Dashboard</p>
                    </div>
                    <section>
                        <div className="card main-card">
                            <div className="card-body px-0 pt-0">
                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-4 dashboard-cards g-4 mb-4">
                                    {data.map((users, index) => (
                                        <div className="col" key={index}>
                                            <div className="card">
                                                <div className="card-body p-0">
                                                    <div className="d-flex align-items-center gap-2 gap-md-3 image-box pt-3 pt-md-4 ps-3 ps-md-4 pb-3">
                                                        <img
                                                            className="user-img"
                                                            src={
                                                                users.image
                                                            }
                                                            alt=""
                                                        />
                                                        <h5>
                                                            {users.title}
                                                        </h5>
                                                    </div>
                                                    <div className="ps-3 ps-md-4 pb-2 pb-md-3 pt-2">
                                                        <p>
                                                            {
                                                                dashboardData[
                                                                users
                                                                    .label
                                                                ]
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="table-main mb-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                                <h5>
                                                    The Latest Entry Form
                                                </h5>
                                                <button
                                                    onClick={() =>
                                                        navigate(
                                                            "/entry-form"
                                                        )
                                                    }
                                                >
                                                    See All{" "}
                                                    <img
                                                        src="../images/png/arrow-circle-right.png"
                                                        width={14}
                                                        height={14}
                                                        alt=""
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-height">
                                            <LatestEntryFormTable
                                                tableData={
                                                    dashboardData?.latestForm
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="table-main">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                                <h5>Recent Signup</h5>
                                                <button
                                                    onClick={() =>
                                                        navigate(
                                                            "/user"
                                                        )
                                                    }
                                                >
                                                    See All{" "}
                                                    <img
                                                        src="../images/png/arrow-circle-right.png"
                                                        width={14}
                                                        height={14}
                                                        alt=""
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-height">
                                            <RecentSignup
                                                tableData={
                                                    dashboardData?.recentUsers
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
